var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5067 8.68395V3.27419C14.5067 2.31268 13.7273 1.5332 12.7657 1.5332H4.5535C3.59197 1.5332 2.8125 2.31268 2.8125 3.27419V23.5487M0.890625 23.5494H9.40847M2.8125 6.00474H7.02985M2.8125 10.3976H9.40847M12.8222 23.5487C12.8313 22.6714 13.0612 21.8106 13.4903 21.0469C14.3947 19.4375 16.1316 18.4156 17.9681 18.4115C19.8044 18.4156 21.5413 19.4375 22.4458 21.0469C22.8749 21.8106 23.1048 22.6714 23.1138 23.5487M17.9681 17.739C19.6253 17.739 20.9686 16.3955 20.9686 14.7383C20.9686 13.0811 19.6253 11.7377 17.9681 11.7377C16.3108 11.7377 14.9674 13.0811 14.9674 14.7383C14.9674 16.3955 16.3108 17.739 17.9681 17.739Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.73d6bb0d978fe2befda2c9f60783c06d.svg";
export { ForwardRef as ReactComponent };